// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =======================================================
   FINANCE DASHBOARD - ADMIN UI
======================================================= */

.dashboard-container {
  background: #f8fafc;
  color: #1a1a1a;
  font-family: "Inter", "Poppins", sans-serif;
  min-height: 100vh;
}

/* --- Header --- */
.dashboard-header h2 {
  font-size: 1.8rem;
  font-weight: 700;
  letter-spacing: -0.3px;
}

.dashboard-header .badge {
  font-size: 0.85rem;
  font-weight: 500;
  background: rgba(13, 110, 253, 0.08) !important;
}

/* --- Card Grid --- */
.dashboard-card-grid {
  margin-top: 1rem;
}

.dashboard-card {
  background: #fff;
  border-radius: 18px;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.dashboard-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.dashboard-card.active {
  border: 2px solid var(--bs-primary);
  box-shadow: 0 6px 18px rgba(13, 110, 253, 0.15);
}

/* --- Icon Styling --- */
.icon-wrapper {
  width: 60px;
  height: 60px;
  border-radius: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-lg {
  width: 28px;
  height: 28px;
}

/* Gradient Backgrounds */
.bg-gradient-success {
  background: linear-gradient(135deg, #28a745, #6fdc8c);
}

.bg-gradient-danger {
  background: linear-gradient(135deg, #dc3545, #ff7f85);
}

.bg-gradient-warning {
  background: linear-gradient(135deg, #ffc107, #ffdb6d);
}

/* --- Placeholder Box --- */
.border-dashed {
  border: 2px dashed rgba(0, 0, 0, 0.1);
}

/* --- Responsive --- */
@media (max-width: 992px) {
  .dashboard-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .dashboard-card {
    padding: 18px 20px;
  }

  .dashboard-card h5 {
    font-size: 1rem;
  }
}

@media (max-width: 768px) {
  .dashboard-card {
    flex-direction: row;
    gap: 12px;
  }

  .icon-wrapper {
    width: 52px;
    height: 52px;
  }

  .icon-lg {
    width: 24px;
    height: 24px;
  }
}

@media (max-width: 576px) {
  .dashboard-header h2 {
    font-size: 1.5rem;
  }

  .dashboard-card {
    padding: 16px;
  }

  .badge {
    font-size: 0.8rem;
  }
}


/* =======================================================
   FILTER PANEL (Used in Payments & Refunds)
======================================================= */

.filter-panel {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease-in-out;
}

.filter-panel:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

/* --- Filter Title & Description --- */
.filter-panel h6 {
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.filter-panel p {
  font-size: 0.875rem;
}

/* --- Dropdown Styling --- */
.filter-control .form-label {
  font-size: 0.875rem;
  color: #6c757d;
  font-weight: 500;
}

.modern-select {
  min-width: 200px;
  font-size: 0.9rem;
  border-radius: 10px;
  padding: 0.5rem 1rem;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
  transition: all 0.2s ease;
  background-color: #fff;
}

.modern-select:hover {
  border-color: var(--bs-primary);
  box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.1);
}

.modern-select:focus {
  border-color: var(--bs-primary);
  outline: none;
  box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.15);
}

/* --- Responsive --- */
@media (max-width: 768px) {
  .filter-panel {
    padding: 1.25rem;
  }

  .filter-control {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  .modern-select {
    width: 100%;
  }
}


/* =======================================================
   FILTER PANEL — Universal for Payments & Refunds
======================================================= */

.filter-panel {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease-in-out;
}

.filter-panel:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.filter-panel h6 {
  font-size: 1rem;
  font-weight: 600;
}

.filter-panel p {
  font-size: 0.875rem;
  margin-bottom: 0;
}

.filter-control {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-control .form-label {
  font-size: 0.875rem;
  color: #6c757d;
  font-weight: 500;
}

.modern-select {
  min-width: 220px;
  font-size: 0.9rem;
  border-radius: 10px;
  padding: 0.55rem 1rem;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
  background-color: #fff;
  transition: all 0.2s ease;
}

.modern-select:hover {
  border-color: var(--bs-primary);
  box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.1);
}

.modern-select:focus {
  border-color: var(--bs-primary);
  outline: none;
  box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.15);
}

/* --- Responsive --- */
@media (max-width: 768px) {
  .filter-panel {
    padding: 1.25rem;
  }

  .filter-control {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  .modern-select {
    width: 100%;
  }
}

/* =======================================================
   SUMMARY CARDS — Used for Today & Total
======================================================= */

.summary-card {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  padding: 1.5rem;
  transition: all 0.25s ease-in-out;
  cursor: pointer;
  height: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.summary-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.07);
}

.summary-card.active {
  border: 2px solid var(--bs-primary);
  box-shadow: 0 4px 16px rgba(13, 110, 253, 0.15);
}

.summary-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.summary-icon {
  width: 54px;
  height: 54px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-md {
  width: 28px;
  height: 28px;
}

/* Gradient Backgrounds */
.bg-gradient-success {
  background: linear-gradient(135deg, #28a745, #6fdc8c);
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #007bff, #74b9ff);
}

/* Summary Text */
.summary-body h4 {
  font-size: 1.5rem;
}

.summary-body span {
  font-weight: 600;
}

/* Responsive */
@media (max-width: 768px) {
  .summary-card {
    padding: 1.25rem;
  }

  .summary-icon {
    width: 48px;
    height: 48px;
  }

  .summary-body h4 {
    font-size: 1.25rem;
  }
}

/* =======================================================
   UNIVERSAL SUMMARY CARD STYLING
======================================================= */

.summary-card {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  padding: 1.5rem;
  transition: all 0.25s ease-in-out;
  cursor: pointer;
  height: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.summary-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.07);
}

.summary-card.active {
  border: 2px solid var(--bs-primary);
  box-shadow: 0 4px 18px rgba(13, 110, 253, 0.15);
}

/* Header & Icon */
.summary-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.summary-icon {
  width: 54px;
  height: 54px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-md {
  width: 28px;
  height: 28px;
}

/* Gradients for Icons */
.bg-gradient-success {
  background: linear-gradient(135deg, #28a745, #6fdc8c);
}

.bg-gradient-danger {
  background: linear-gradient(135deg, #dc3545, #ff7f85);
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #007bff, #74b9ff);
}

.bg-gradient-info {
  background: linear-gradient(135deg, #0dcaf0, #71d7ff);
}

.bg-gradient-warning {
  background: linear-gradient(135deg, #ffc107, #ffe480);
}

/* Body Text */
.summary-body h4 {
  font-size: 1.5rem;
}

.summary-body p {
  font-size: 0.875rem;
}

/* Date Input */
.modern-date-input {
  max-width: 180px;
  border-radius: 8px;
  font-size: 0.9rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 0.4rem 0.6rem;
  transition: all 0.2s ease;
}

.modern-date-input:hover {
  border-color: var(--bs-primary);
}

.modern-date-input:focus {
  border-color: var(--bs-primary);
  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);
  outline: none;
}

/* Responsive */
@media (max-width: 768px) {
  .summary-card {
    padding: 1.25rem;
  }

  .summary-icon {
    width: 48px;
    height: 48px;
  }

  .summary-body h4 {
    font-size: 1.25rem;
  }

  .modern-date-input {
    width: 100%;
  }
}

/* =======================================================
   MODERN TABLE DESIGN
======================================================= */

.modern-table-wrapper {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.25s ease;
}

.modern-table {
  margin-bottom: 0;
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
}

.modern-table thead {
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  border-bottom: 2px solid rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 1;
}

.modern-table th {
  font-weight: 600;
  font-size: 0.875rem;
  color: #495057;
  text-transform: uppercase;
  padding: 0.9rem 1rem;
  white-space: nowrap;
  background-color: #f8f9fa;
}

.modern-table td {
  padding: 0.9rem 1rem;
  font-size: 0.92rem;
  vertical-align: middle;
  color: #212529;
}

.modern-table tbody tr {
  transition: all 0.15s ease;
}

.modern-table tbody tr:hover {
  background-color: rgba(13, 110, 253, 0.05);
  transform: scale(1.002);
}

.modern-table tbody tr:last-child td {
  border-bottom: none;
}

.modern-table td.text-success {
  font-weight: 600;
}

/* --- Empty State --- */
.empty-state {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.empty-state p {
  font-size: 0.95rem;
}

/* --- Scroll Styling --- */
.table-responsive::-webkit-scrollbar {
  height: 8px;
}

.table-responsive::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: 10px;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.25);
}

/* --- Responsive --- */
@media (max-width: 768px) {
  .modern-table th,
  .modern-table td {
    padding: 0.75rem 0.5rem;
    font-size: 0.85rem;
  }

  .modern-table-wrapper {
    border-radius: 12px;
  }
}

/* =======================================================
   REFUND TABLE STYLES (Based on Modern Table)
======================================================= */

.refund-table thead {
  background: linear-gradient(135deg, #fff5f5, #ffffff);
  border-bottom: 2px solid rgba(220, 53, 69, 0.1);
}

.refund-table th {
  color: #dc3545;
}

.refund-table td.text-danger {
  font-weight: 600;
}

.refund-table tbody tr:hover {
  background-color: rgba(220, 53, 69, 0.05);
  transform: scale(1.002);
}

/* Empty state reused */
.empty-state {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.empty-state p {
  font-size: 0.95rem;
}

/* Scrollbar and responsiveness reused */
.table-responsive::-webkit-scrollbar {
  height: 8px;
}

.table-responsive::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: 10px;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.25);
}

@media (max-width: 768px) {
  .refund-table th,
  .refund-table td {
    padding: 0.75rem 0.5rem;
    font-size: 0.85rem;
  }

  .modern-table-wrapper {
    border-radius: 12px;
  }
}


/* =======================================================
   MODERN ADMIN MODALS
======================================================= */

.modal-content {
  border: none;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 6px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

/* Header */
.modal-header {
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 1.25rem 1.5rem;
}

.modal-title {
  font-weight: 700;
  color: #212529;
}

.btn-close {
  filter: brightness(0.5);
  transition: filter 0.2s ease;
}

.btn-close:hover {
  filter: brightness(0.2);
}

/* Body */
.modal-body {
  padding: 1.5rem 1.5rem;
  color: #212529;
  background-color: #fff;
}

.modal-body h3,
.modal-body h4,
.modal-body h5 {
  font-weight: 700;
  color: #212529;
  margin-bottom: 1rem;
}

/* Summary Cards inside Modals */
.modal-body .bg-light {
  background-color: #f8f9fb !important;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04);
  transition: all 0.2s ease;
}

.modal-body .bg-light:hover {
  transform: translateY(-2px);
}

/* Modal Footer */
.modal-footer {
  background-color: #f9fafb;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Buttons */
.btn-success {
  background: linear-gradient(135deg, #28a745, #6fdc8c);
  border: none;
  font-weight: 600;
  transition: all 0.25s ease;
}

.btn-success:hover {
  background: linear-gradient(135deg, #23923c, #63ce7c);
  transform: translateY(-1px);
}

.btn-secondary {
  background: linear-gradient(135deg, #adb5bd, #ced4da);
  border: none;
  color: #212529;
  font-weight: 500;
}

.btn-secondary:hover {
  background: linear-gradient(135deg, #9ca3af, #bfc5ca);
}

/* Scrollbar inside modal content */
.modal-dialog-scrollable .modal-body::-webkit-scrollbar {
  width: 8px;
}

.modal-dialog-scrollable .modal-body::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: 10px;
}

.modal-dialog-scrollable .modal-body::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.25);
}

/* Tables inside modal */
.modal-body .modern-table-wrapper {
  margin-top: 0.75rem;
}

.modal-body .modern-table thead {
  position: sticky;
  top: 0;
  z-index: 5;
}

/* Fade animation */
.modal.fade.show .modal-dialog {
  transform: translateY(0);
  transition: transform 0.3s ease-out;
}

.modal.fade .modal-dialog {
  transform: translateY(-20px);
  transition: transform 0.3s ease-in;
}

/* Responsive tweaks */
@media (max-width: 768px) {
  .modal-body {
    padding: 1rem;
  }

  .modal-footer {
    flex-direction: column;
    gap: 0.5rem;
  }

  .modal-title {
    font-size: 1.1rem;
  }
}

/* ==========================================
   Modern DataTable Styling (MDB Theme)
========================================== */



table.dataTable thead:last-of-type {
  display: none !important;
}


`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/DashboardStatistics.css"],"names":[],"mappings":"AAAA;;yDAEyD;;AAEzD;EACE,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iCAAiC;EACjC,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA,4BAA4B;AAC5B;EACE,qCAAqC;AACvC;;AAEA,uBAAuB;AACvB;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;;AAGA;;yDAEyD;;AAEzD;EACE,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,qCAAqC;EACrC,yCAAyC;EACzC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;;AAGA;;yDAEyD;;AAEzD;EACE,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,qCAAqC;EACrC,yCAAyC;EACzC,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;yDAEyD;;AAEzD;EACE,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;;yDAEyD;;AAEzD;EACE,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA,cAAc;AACd;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC;EACpC,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;EAC7C,aAAa;AACf;;AAEA,eAAe;AACf;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;yDAEyD;;AAEzD;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,4CAA4C;EAC5C,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,uBAAuB;AACvB;EACE;;IAEE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;yDAEyD;;AAEzD;EACE,qDAAqD;EACrD,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;;IAEE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;;AAGA;;yDAEyD;;AAEzD;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,qDAAqD;EACrD,4CAA4C;EAC5C,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA,SAAS;AACT;EACE,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;;;EAGE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,oCAAoC;EACpC,qCAAqC;EACrC,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,yCAAyC;EACzC,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,qDAAqD;EACrD,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA,mCAAmC;AACnC;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;;4CAE4C;;;;AAI5C;EACE,wBAAwB;AAC1B","sourcesContent":["/* =======================================================\r\n   FINANCE DASHBOARD - ADMIN UI\r\n======================================================= */\r\n\r\n.dashboard-container {\r\n  background: #f8fafc;\r\n  color: #1a1a1a;\r\n  font-family: \"Inter\", \"Poppins\", sans-serif;\r\n  min-height: 100vh;\r\n}\r\n\r\n/* --- Header --- */\r\n.dashboard-header h2 {\r\n  font-size: 1.8rem;\r\n  font-weight: 700;\r\n  letter-spacing: -0.3px;\r\n}\r\n\r\n.dashboard-header .badge {\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n  background: rgba(13, 110, 253, 0.08) !important;\r\n}\r\n\r\n/* --- Card Grid --- */\r\n.dashboard-card-grid {\r\n  margin-top: 1rem;\r\n}\r\n\r\n.dashboard-card {\r\n  background: #fff;\r\n  border-radius: 18px;\r\n  padding: 20px 24px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  cursor: pointer;\r\n  transition: all 0.25s ease-in-out;\r\n  border: 1px solid rgba(0, 0, 0, 0.05);\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.dashboard-card:hover {\r\n  transform: translateY(-3px);\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.dashboard-card.active {\r\n  border: 2px solid var(--bs-primary);\r\n  box-shadow: 0 6px 18px rgba(13, 110, 253, 0.15);\r\n}\r\n\r\n/* --- Icon Styling --- */\r\n.icon-wrapper {\r\n  width: 60px;\r\n  height: 60px;\r\n  border-radius: 14px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.icon-lg {\r\n  width: 28px;\r\n  height: 28px;\r\n}\r\n\r\n/* Gradient Backgrounds */\r\n.bg-gradient-success {\r\n  background: linear-gradient(135deg, #28a745, #6fdc8c);\r\n}\r\n\r\n.bg-gradient-danger {\r\n  background: linear-gradient(135deg, #dc3545, #ff7f85);\r\n}\r\n\r\n.bg-gradient-warning {\r\n  background: linear-gradient(135deg, #ffc107, #ffdb6d);\r\n}\r\n\r\n/* --- Placeholder Box --- */\r\n.border-dashed {\r\n  border: 2px dashed rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* --- Responsive --- */\r\n@media (max-width: 992px) {\r\n  .dashboard-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 1rem;\r\n  }\r\n\r\n  .dashboard-card {\r\n    padding: 18px 20px;\r\n  }\r\n\r\n  .dashboard-card h5 {\r\n    font-size: 1rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .dashboard-card {\r\n    flex-direction: row;\r\n    gap: 12px;\r\n  }\r\n\r\n  .icon-wrapper {\r\n    width: 52px;\r\n    height: 52px;\r\n  }\r\n\r\n  .icon-lg {\r\n    width: 24px;\r\n    height: 24px;\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .dashboard-header h2 {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .dashboard-card {\r\n    padding: 16px;\r\n  }\r\n\r\n  .badge {\r\n    font-size: 0.8rem;\r\n  }\r\n}\r\n\r\n\r\n/* =======================================================\r\n   FILTER PANEL (Used in Payments & Refunds)\r\n======================================================= */\r\n\r\n.filter-panel {\r\n  background: #ffffff;\r\n  border: 1px solid rgba(0, 0, 0, 0.05);\r\n  border-radius: 16px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\n.filter-panel:hover {\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n/* --- Filter Title & Description --- */\r\n.filter-panel h6 {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.filter-panel p {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n/* --- Dropdown Styling --- */\r\n.filter-control .form-label {\r\n  font-size: 0.875rem;\r\n  color: #6c757d;\r\n  font-weight: 500;\r\n}\r\n\r\n.modern-select {\r\n  min-width: 200px;\r\n  font-size: 0.9rem;\r\n  border-radius: 10px;\r\n  padding: 0.5rem 1rem;\r\n  border: 1px solid rgba(0, 0, 0, 0.08);\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);\r\n  transition: all 0.2s ease;\r\n  background-color: #fff;\r\n}\r\n\r\n.modern-select:hover {\r\n  border-color: var(--bs-primary);\r\n  box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.1);\r\n}\r\n\r\n.modern-select:focus {\r\n  border-color: var(--bs-primary);\r\n  outline: none;\r\n  box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.15);\r\n}\r\n\r\n/* --- Responsive --- */\r\n@media (max-width: 768px) {\r\n  .filter-panel {\r\n    padding: 1.25rem;\r\n  }\r\n\r\n  .filter-control {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    width: 100%;\r\n  }\r\n\r\n  .modern-select {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n\r\n/* =======================================================\r\n   FILTER PANEL — Universal for Payments & Refunds\r\n======================================================= */\r\n\r\n.filter-panel {\r\n  background: #ffffff;\r\n  border: 1px solid rgba(0, 0, 0, 0.05);\r\n  border-radius: 16px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n\r\n.filter-panel:hover {\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.filter-panel h6 {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.filter-panel p {\r\n  font-size: 0.875rem;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.filter-control {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.filter-control .form-label {\r\n  font-size: 0.875rem;\r\n  color: #6c757d;\r\n  font-weight: 500;\r\n}\r\n\r\n.modern-select {\r\n  min-width: 220px;\r\n  font-size: 0.9rem;\r\n  border-radius: 10px;\r\n  padding: 0.55rem 1rem;\r\n  border: 1px solid rgba(0, 0, 0, 0.08);\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);\r\n  background-color: #fff;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.modern-select:hover {\r\n  border-color: var(--bs-primary);\r\n  box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.1);\r\n}\r\n\r\n.modern-select:focus {\r\n  border-color: var(--bs-primary);\r\n  outline: none;\r\n  box-shadow: 0 0 0 4px rgba(13, 110, 253, 0.15);\r\n}\r\n\r\n/* --- Responsive --- */\r\n@media (max-width: 768px) {\r\n  .filter-panel {\r\n    padding: 1.25rem;\r\n  }\r\n\r\n  .filter-control {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    width: 100%;\r\n  }\r\n\r\n  .modern-select {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n/* =======================================================\r\n   SUMMARY CARDS — Used for Today & Total\r\n======================================================= */\r\n\r\n.summary-card {\r\n  background: #fff;\r\n  border: 1px solid rgba(0, 0, 0, 0.05);\r\n  border-radius: 16px;\r\n  padding: 1.5rem;\r\n  transition: all 0.25s ease-in-out;\r\n  cursor: pointer;\r\n  height: 100%;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.summary-card:hover {\r\n  transform: translateY(-3px);\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.07);\r\n}\r\n\r\n.summary-card.active {\r\n  border: 2px solid var(--bs-primary);\r\n  box-shadow: 0 4px 16px rgba(13, 110, 253, 0.15);\r\n}\r\n\r\n.summary-card-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n}\r\n\r\n.summary-icon {\r\n  width: 54px;\r\n  height: 54px;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.icon-md {\r\n  width: 28px;\r\n  height: 28px;\r\n}\r\n\r\n/* Gradient Backgrounds */\r\n.bg-gradient-success {\r\n  background: linear-gradient(135deg, #28a745, #6fdc8c);\r\n}\r\n\r\n.bg-gradient-primary {\r\n  background: linear-gradient(135deg, #007bff, #74b9ff);\r\n}\r\n\r\n/* Summary Text */\r\n.summary-body h4 {\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.summary-body span {\r\n  font-weight: 600;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .summary-card {\r\n    padding: 1.25rem;\r\n  }\r\n\r\n  .summary-icon {\r\n    width: 48px;\r\n    height: 48px;\r\n  }\r\n\r\n  .summary-body h4 {\r\n    font-size: 1.25rem;\r\n  }\r\n}\r\n\r\n/* =======================================================\r\n   UNIVERSAL SUMMARY CARD STYLING\r\n======================================================= */\r\n\r\n.summary-card {\r\n  background: #ffffff;\r\n  border: 1px solid rgba(0, 0, 0, 0.05);\r\n  border-radius: 16px;\r\n  padding: 1.5rem;\r\n  transition: all 0.25s ease-in-out;\r\n  cursor: pointer;\r\n  height: 100%;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);\r\n}\r\n\r\n.summary-card:hover {\r\n  transform: translateY(-3px);\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.07);\r\n}\r\n\r\n.summary-card.active {\r\n  border: 2px solid var(--bs-primary);\r\n  box-shadow: 0 4px 18px rgba(13, 110, 253, 0.15);\r\n}\r\n\r\n/* Header & Icon */\r\n.summary-card-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n}\r\n\r\n.summary-icon {\r\n  width: 54px;\r\n  height: 54px;\r\n  border-radius: 12px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.icon-md {\r\n  width: 28px;\r\n  height: 28px;\r\n}\r\n\r\n/* Gradients for Icons */\r\n.bg-gradient-success {\r\n  background: linear-gradient(135deg, #28a745, #6fdc8c);\r\n}\r\n\r\n.bg-gradient-danger {\r\n  background: linear-gradient(135deg, #dc3545, #ff7f85);\r\n}\r\n\r\n.bg-gradient-primary {\r\n  background: linear-gradient(135deg, #007bff, #74b9ff);\r\n}\r\n\r\n.bg-gradient-info {\r\n  background: linear-gradient(135deg, #0dcaf0, #71d7ff);\r\n}\r\n\r\n.bg-gradient-warning {\r\n  background: linear-gradient(135deg, #ffc107, #ffe480);\r\n}\r\n\r\n/* Body Text */\r\n.summary-body h4 {\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.summary-body p {\r\n  font-size: 0.875rem;\r\n}\r\n\r\n/* Date Input */\r\n.modern-date-input {\r\n  max-width: 180px;\r\n  border-radius: 8px;\r\n  font-size: 0.9rem;\r\n  border: 1px solid rgba(0, 0, 0, 0.1);\r\n  padding: 0.4rem 0.6rem;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.modern-date-input:hover {\r\n  border-color: var(--bs-primary);\r\n}\r\n\r\n.modern-date-input:focus {\r\n  border-color: var(--bs-primary);\r\n  box-shadow: 0 0 0 3px rgba(13, 110, 253, 0.1);\r\n  outline: none;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .summary-card {\r\n    padding: 1.25rem;\r\n  }\r\n\r\n  .summary-icon {\r\n    width: 48px;\r\n    height: 48px;\r\n  }\r\n\r\n  .summary-body h4 {\r\n    font-size: 1.25rem;\r\n  }\r\n\r\n  .modern-date-input {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n/* =======================================================\r\n   MODERN TABLE DESIGN\r\n======================================================= */\r\n\r\n.modern-table-wrapper {\r\n  background: #ffffff;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);\r\n  transition: all 0.25s ease;\r\n}\r\n\r\n.modern-table {\r\n  margin-bottom: 0;\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n  width: 100%;\r\n}\r\n\r\n.modern-table thead {\r\n  background: linear-gradient(135deg, #f8f9fa, #ffffff);\r\n  border-bottom: 2px solid rgba(0, 0, 0, 0.05);\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.modern-table th {\r\n  font-weight: 600;\r\n  font-size: 0.875rem;\r\n  color: #495057;\r\n  text-transform: uppercase;\r\n  padding: 0.9rem 1rem;\r\n  white-space: nowrap;\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.modern-table td {\r\n  padding: 0.9rem 1rem;\r\n  font-size: 0.92rem;\r\n  vertical-align: middle;\r\n  color: #212529;\r\n}\r\n\r\n.modern-table tbody tr {\r\n  transition: all 0.15s ease;\r\n}\r\n\r\n.modern-table tbody tr:hover {\r\n  background-color: rgba(13, 110, 253, 0.05);\r\n  transform: scale(1.002);\r\n}\r\n\r\n.modern-table tbody tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n.modern-table td.text-success {\r\n  font-weight: 600;\r\n}\r\n\r\n/* --- Empty State --- */\r\n.empty-state {\r\n  background: #fff;\r\n  border-radius: 16px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.empty-state p {\r\n  font-size: 0.95rem;\r\n}\r\n\r\n/* --- Scroll Styling --- */\r\n.table-responsive::-webkit-scrollbar {\r\n  height: 8px;\r\n}\r\n\r\n.table-responsive::-webkit-scrollbar-thumb {\r\n  background-color: rgba(0, 0, 0, 0.15);\r\n  border-radius: 10px;\r\n}\r\n\r\n.table-responsive::-webkit-scrollbar-thumb:hover {\r\n  background-color: rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n/* --- Responsive --- */\r\n@media (max-width: 768px) {\r\n  .modern-table th,\r\n  .modern-table td {\r\n    padding: 0.75rem 0.5rem;\r\n    font-size: 0.85rem;\r\n  }\r\n\r\n  .modern-table-wrapper {\r\n    border-radius: 12px;\r\n  }\r\n}\r\n\r\n/* =======================================================\r\n   REFUND TABLE STYLES (Based on Modern Table)\r\n======================================================= */\r\n\r\n.refund-table thead {\r\n  background: linear-gradient(135deg, #fff5f5, #ffffff);\r\n  border-bottom: 2px solid rgba(220, 53, 69, 0.1);\r\n}\r\n\r\n.refund-table th {\r\n  color: #dc3545;\r\n}\r\n\r\n.refund-table td.text-danger {\r\n  font-weight: 600;\r\n}\r\n\r\n.refund-table tbody tr:hover {\r\n  background-color: rgba(220, 53, 69, 0.05);\r\n  transform: scale(1.002);\r\n}\r\n\r\n/* Empty state reused */\r\n.empty-state {\r\n  background: #fff;\r\n  border-radius: 16px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.empty-state p {\r\n  font-size: 0.95rem;\r\n}\r\n\r\n/* Scrollbar and responsiveness reused */\r\n.table-responsive::-webkit-scrollbar {\r\n  height: 8px;\r\n}\r\n\r\n.table-responsive::-webkit-scrollbar-thumb {\r\n  background-color: rgba(0, 0, 0, 0.15);\r\n  border-radius: 10px;\r\n}\r\n\r\n.table-responsive::-webkit-scrollbar-thumb:hover {\r\n  background-color: rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .refund-table th,\r\n  .refund-table td {\r\n    padding: 0.75rem 0.5rem;\r\n    font-size: 0.85rem;\r\n  }\r\n\r\n  .modern-table-wrapper {\r\n    border-radius: 12px;\r\n  }\r\n}\r\n\r\n\r\n/* =======================================================\r\n   MODERN ADMIN MODALS\r\n======================================================= */\r\n\r\n.modal-content {\r\n  border: none;\r\n  border-radius: 18px;\r\n  background: #ffffff;\r\n  box-shadow: 0 6px 32px rgba(0, 0, 0, 0.1);\r\n  overflow: hidden;\r\n}\r\n\r\n/* Header */\r\n.modal-header {\r\n  background: linear-gradient(135deg, #f8f9fa, #ffffff);\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\r\n  padding: 1.25rem 1.5rem;\r\n}\r\n\r\n.modal-title {\r\n  font-weight: 700;\r\n  color: #212529;\r\n}\r\n\r\n.btn-close {\r\n  filter: brightness(0.5);\r\n  transition: filter 0.2s ease;\r\n}\r\n\r\n.btn-close:hover {\r\n  filter: brightness(0.2);\r\n}\r\n\r\n/* Body */\r\n.modal-body {\r\n  padding: 1.5rem 1.5rem;\r\n  color: #212529;\r\n  background-color: #fff;\r\n}\r\n\r\n.modal-body h3,\r\n.modal-body h4,\r\n.modal-body h5 {\r\n  font-weight: 700;\r\n  color: #212529;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n/* Summary Cards inside Modals */\r\n.modal-body .bg-light {\r\n  background-color: #f8f9fb !important;\r\n  border: 1px solid rgba(0, 0, 0, 0.05);\r\n  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.04);\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.modal-body .bg-light:hover {\r\n  transform: translateY(-2px);\r\n}\r\n\r\n/* Modal Footer */\r\n.modal-footer {\r\n  background-color: #f9fafb;\r\n  border-top: 1px solid rgba(0, 0, 0, 0.05);\r\n  padding: 1rem 1.5rem;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n/* Buttons */\r\n.btn-success {\r\n  background: linear-gradient(135deg, #28a745, #6fdc8c);\r\n  border: none;\r\n  font-weight: 600;\r\n  transition: all 0.25s ease;\r\n}\r\n\r\n.btn-success:hover {\r\n  background: linear-gradient(135deg, #23923c, #63ce7c);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.btn-secondary {\r\n  background: linear-gradient(135deg, #adb5bd, #ced4da);\r\n  border: none;\r\n  color: #212529;\r\n  font-weight: 500;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background: linear-gradient(135deg, #9ca3af, #bfc5ca);\r\n}\r\n\r\n/* Scrollbar inside modal content */\r\n.modal-dialog-scrollable .modal-body::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n.modal-dialog-scrollable .modal-body::-webkit-scrollbar-thumb {\r\n  background-color: rgba(0, 0, 0, 0.15);\r\n  border-radius: 10px;\r\n}\r\n\r\n.modal-dialog-scrollable .modal-body::-webkit-scrollbar-thumb:hover {\r\n  background-color: rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n/* Tables inside modal */\r\n.modal-body .modern-table-wrapper {\r\n  margin-top: 0.75rem;\r\n}\r\n\r\n.modal-body .modern-table thead {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 5;\r\n}\r\n\r\n/* Fade animation */\r\n.modal.fade.show .modal-dialog {\r\n  transform: translateY(0);\r\n  transition: transform 0.3s ease-out;\r\n}\r\n\r\n.modal.fade .modal-dialog {\r\n  transform: translateY(-20px);\r\n  transition: transform 0.3s ease-in;\r\n}\r\n\r\n/* Responsive tweaks */\r\n@media (max-width: 768px) {\r\n  .modal-body {\r\n    padding: 1rem;\r\n  }\r\n\r\n  .modal-footer {\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  .modal-title {\r\n    font-size: 1.1rem;\r\n  }\r\n}\r\n\r\n/* ==========================================\r\n   Modern DataTable Styling (MDB Theme)\r\n========================================== */\r\n\r\n\r\n\r\ntable.dataTable thead:last-of-type {\r\n  display: none !important;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
